import gql from 'graphql-tag';

export const CREATE_CLIENT = gql`
	mutation createClientMutation($input: CreateClientInput!) {
		createClient(input: $input) {
			id
			name
			addressObj {
				id
				region
				street
				city
				postcode
			}
			locations {
				id
			}
			person {
				id
			}
			secondaryPerson {
				id
			}
			commission {
				id
			}
		}
	}
`;
